import React from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import { PopoverTabButtonToggle } from './PopoverTabButtonToggle';
import { SPACING } from '../../styles/spacing';
import { mainTheme } from '@plecto/ui';

const minDropdownWidth = 270;

const S = {};
// Embedded in a form (popupDisabled), the search sits on the panel's own surface
// the way the UI library's searchable Dropdown does — no box around it and no rule
// under it. It used to draw a bordered header with a divider, which read as a
// separate control stacked on the list rather than part of it.
S.ButtonToggleContainer = styled.div.attrs(props => ({
	...(props.popupDisabled && {
		padding: `${SPACING.smaller} ${SPACING.big}`,
	}),
	height: props.size === 'sm' && '30px' || '38px',
}))`
	.multi-level-dropdown-toggle-container {
		background-color: ${mainTheme.form.dropdown.box.background};
		padding: ${props => props.padding};
		// Menu rows are 14px; the search reads as one of them.
		font-size: 14px;
	}
	.popover-tab-button {
		min-height: ${props => props.height};
	}
`;

export default function MultiLevelDropdownWrapper({
	children,
	toggle,
	onOpen,
	className,
	label,
	open,
	placement,
	popupDisabled,
	size,
	minWidth = minDropdownWidth,
	padding
}) {
	return <S.ButtonToggleContainer
		size={size}
		popupDisabled={popupDisabled}
		className={'multi-level-dropdown-container'}
	>
		{popupDisabled ?
			<>
				{toggle}
				{children}
			</> : <PopoverTabButtonToggle
				className={classNames(className, 'multi-level-dropdown-toggle')}
				popupDisabled={popupDisabled}
				name={label}
				open={open}
				padding={padding}
				placement={placement}
				onOpen={onOpen}
				sameWidth
				minWidth={minWidth}
				buttonControl={toggle}
			>
				{children}
			</PopoverTabButtonToggle>}
	</S.ButtonToggleContainer>;
}
